import React, { memo } from 'react';

import { Modal } from 'Components/Modal';

import { PurpleButton } from 'Components/Button';

import { ExternalAtmosphericLog } from 'Containers/RocketDry/types';

import { areEqual } from 'Utils/equalityChecks';
import classes from './deleteAtmosphericLogModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;

  // log variable
  atmosphericLog: ExternalAtmosphericLog;

  // modal functions
  onDeleteButtonClick: (e: any) => void;
  closeModal: (e: any) => void;
}

function DeleteExternalAtmosphericLogModal({ isOpen, atmosphericLog, onDeleteButtonClick, closeModal }: Props) {
  return (
    <Modal
      title="Delete Atmospheric Log?"
      isOpen={isOpen}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={closeModal}
    >
      <div className={classes.modalBody}>
        <p>
          Are you sure you want to delete this atmospheric log?
          <br />
        </p>
        <div className={classes.logInfo}>
          <div className={classes.logItem}>
            <div>Relative Humidity</div>
            <span>{atmosphericLog?.relativeHumidity ? `${atmosphericLog.relativeHumidity} %` : ' - '}</span>
          </div>
          <div className={classes.logItem}>
            <div>Temperature</div>
            <span>{atmosphericLog?.temperature ? `${atmosphericLog.temperature} °F` : ' - '}</span>
          </div>
          <div className={classes.logItem}>
            <div>Pressure</div>
            <span>{atmosphericLog?.pressure ? `${atmosphericLog.pressure} kPA` : ' - '}</span>
          </div>
          <div className={classes.logItem}>
            <div>Wind Speed</div>
            <span>{atmosphericLog?.windSpeed ? `${atmosphericLog.windSpeed} mph` : ' - '}</span>
          </div>
        </div>
        <p>You will not be able to undo this action.</p>
      </div>

      <div className={`modal-footer ${classes.modalFooter}`}>
        <PurpleButton onClick={closeModal} className={classes.cancelButton}>
          Cancel
        </PurpleButton>
        <PurpleButton onClick={onDeleteButtonClick} className={classes.deleteButton}>
          Delete
        </PurpleButton>
      </div>
    </Modal>
  );
}

const DeleteExternalAtmosphericLogModalMemo = memo(DeleteExternalAtmosphericLogModal, areEqual);
export { DeleteExternalAtmosphericLogModalMemo as DeleteExternalAtmosphericLogModal };
